module.exports = __webpack_public_path__ + "assets/img/Type E (77).2df98c46.jpg";